<template>
  <CategoryForm action="create" />
</template>

<script>
import CategoryForm from '@/components/Category/CategoryForm'

export default {
  components: {
    CategoryForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/category/Create.vue